import type * as Item from "../../lib/models/item.server.ts"

import * as React from "react"
import * as ItemsGrid from "../../lib/ui/items-grid.tsx"
import * as Query from "../../lib/utils/query.ts"

import { useLang } from "../../lib/lang/use-lang.ts"

type Props = {
  filterOptions: Item.FilterOptionsWithCount
}

export const ItemsFilter = ({ filterOptions: filterOptionsProp }: Props) => {
  const lang = useLang()

  const filterOptions = React.useMemo(() => {
    return filterOptionsProp.options.map((filterOption) => ({
      id: filterOption.value,
      value: getFilterLabel(filterOption.value),
      quantity: filterOption.count,
    }))
  }, [filterOptionsProp, lang])

  function getFilterLabel(filterOption: Item.FilterBy) {
    switch (filterOption) {
      case "all":
        return lang.terms.ALL
      case "shop":
        return lang.terms.SHOP
      default:
        return filterOption
    }
  }

  return (
    <ItemsGrid.ItemsFilter
      of={filterOptions}
      defaultValue={filterOptionsProp.default}
      queryParam={Query.FILTER_BY_PARAM}
    />
  )
}
